"use client";

import { Button } from "@mui/material";
import { useDeleteDialog } from "../Providers/DeleteDialogContext";

export default function CancelButton() {
  const { closeDeleteDialog } = useDeleteDialog();

  return (
    <Button onClick={closeDeleteDialog} type="button">
      Cancel
    </Button>
  );
}
